const projects=[
    {
        id:1,
        name:'Real-Kart',
        link:'https://iiitblogapp.herokuapp.com/',
        image:'../Covid-Care.PNG',
        desc:'Created an Cart functionality as in E-commerce websites using react. Items are displayed from dummy data where user can add items to cart , checkout them and can place order',
        github:'https://github.com/Rahul-Palahwat/Real_Kart'
    },
    {
        id:2,
        name:'iNotebook',
        link:'https://iiitblogapp.herokuapp.com/',
        image:'../algo-visualizer.PNG',
        desc:'Created a Notebook app where user can keep his notes secure on the cloud and can access,edit and delete them. To save notes user have to get himself registered then he can login with his account and can access his notes.',
        github:'https://github.com/Rahul-Palahwat/iNotebook-cloud'
    },
    {
        id:3,
        name:'MyBlogs',
        link:'https://iiitblogapp.herokuapp.com/',
        image:'../Ecommerce.PNG',
        desc:'Web application which is like facebook, here user can post blogs, read blogs ,update blogs and can also see other users blog',
        github:'https://github.com/Rahul-Palahwat/Django_full_featured_app'
    },
    {
        id:4,
        name:'NewsMonkey - News',
        link:'https://iiitblogapp.herokuapp.com/',
        image:'../News-App.PNG',
        desc:'It is a react Application to show the latest and trending news and other news using filters. Technologies used are NodeJS, Express.js, MongoDB, ReactJS, Material UI and https://developer.nytimes.com/apis API. JWTs are used for authentication.',
        github:'https://github.com/Rahul-Palahwat/NewsMonkey-News'
    }
]
export default projects